import { render, staticRenderFns } from "./SBUJK.vue?vue&type=template&id=22ed4ff4&"
import script from "./SBUJK.vue?vue&type=script&lang=js&"
export * from "./SBUJK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports